export const ADDRESS_TYPE = {
  Shipping: 'Shipping',
  Billing: 'Billing',
} as const;

export type AddressType = typeof ADDRESS_TYPE[keyof typeof ADDRESS_TYPE];
